import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer } from "../../components/Footer";
import Header from "../../components/Header";
import patient from "../../assets/img/patient.jpg";
import React, { useEffect, useState } from "react";
import { CallWithAuth } from "../../action/apiActions";
import {
  GET_DOCTOR_PATIENT_ASSESMENT,
  GET_PATIENT_RELATIVES_API_URL,
  GET_PROMPTS,
  PATIENT_ASSESSMWNT_RECOMMENDED,
  PATIENT_ASSESSMWNT_SUBMIT,
  SEND_MAIL_PATIENT_RELATIVES_API_URL,
  SEND_PATIENT_ASSESMENT,
  VALIDATE_URL,
} from "../../action/apiPath";
import {
  errorMessageCreate,
  fileName,
  safeMarkedWrapper,
  textRetriever,
} from "../../util/custom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { showToast, ToastContainer } from "../../util/toastHelper";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { marked } from "marked";
import PromptEditor from "../../components/PromptEditor/Index";
import axios from "axios";

const MySwal = withReactContent(Swal);
const staticRelatives = [
  {
    id: 1,
    name: "Srikanth Y",
    email: "test1@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 2,
    name: "Srikanth G",
    email: "test2@yopmail.com",
    phone: "1236547890",
    isChecked: false,
  },
  {
    id: 3,
    name: "Srikanth M",
    email: "test3@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 4,
    name: "Srikanth M",
    email: "test4@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
];

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const PatientAssesmentPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [getRelativesDataDeatil, setRelativesDataDeatil] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [assesment_loading, setisAddeAssesment] = useState(false);
  const [hasSubmitByPatient, setHasSubmitByPatient] = useState(false);
  const [hasSubmitByDoctor, setHasSubmitByDoctor] = useState(true);

  const [isAddedAssessment, setIsAddedAssessment] = useState(false);
  const [isSubmitAssesmentLoading, setSubmitAssesmentLoading] = useState(false);
  const [isGetRecommendation, setIsGetRecommendation] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [recommendationDeatil, setRecommendationDeatil] = React.useState("");
  const [count, setCount] = React.useState(0);
  const [links, setLinks] = useState([""]); // Start with one input
  const [submittedLink, setSubmittedLink] = useState([]); // Start with one input
  const [isAssesmentAdded, setIsAssesmentAdded] = useState(false); // Start with one input
  const [promptResult, setPromptResult] = useState([]);
  const [isUpadatedPrompt, setUpdatedPrompt] = useState(false);
  const [promptTextChange, setPromptTextChange] = useState(false);


  const [error, setError] = useState("");
  useEffect(() => {
    if (id == undefined || id == "") {
      navigate("/");
      return;
    }
    getReleatives();
    getAssesmentFromSubmitDetail();
    getProptsDeatils();
  }, [id]);
  const onHide = () => setModalShow(false);

  const getProptsDeatils = async () => {
    //  setIsProptsApiCall(true);
    //  setIsLoading(true);
     try {
       const response = await CallWithAuth(
         "GET",
         `${GET_PROMPTS}`
       );
       if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
         setPromptResult(response.res.data.data);
       }
       setIsLoading(false);
     } catch (error) {
      
     }
  }
  /**
   * Fetch the relatives data from the API
   * @param {string} id The patient id
   * @returns {Promise<void>}
   */
  const getReleatives = async () => {
    try {
      /**
       * The API endpoint to fetch the relatives data
       * @type {string}
       */
      const url = `${GET_PATIENT_RELATIVES_API_URL}/${id}/?extra=true`;

      const response = await CallWithAuth("GET", url);

      if (response.res.data && response.res.data.statusCode === 200) {
        /**
         * The relatives data fetched from the API
         * @type {Array<Object>}
         */
        // setRelativesData(response.res.data.data.relatives ?? []);
        // setRelativesDocs(response.res.data.data.reports ?? []);
        setRelativesDataDeatil(response.res.data.data);
      }
      // setIsLoading(false);
    } catch (error) {}
  };

  const getAssesmentFromSubmitDetail = async (message='') => {
    try {
      /**
       * The API endpoint to fetch the relatives data
       * @type {string}
       */
      const url = `${GET_DOCTOR_PATIENT_ASSESMENT}${id}`;

      const response = await CallWithAuth("GET", url);
      setHasSubmitByDoctor(true);
      if (response.res.data && response.res.data.statusCode === 200) {
        // console.log("response==>",response.res.data.data);
        
        let submitLinkList = response.res.data.data?.assessments;
        if (response.res.data.data?.assessments?.length > 0) {
          setIsAddedAssessment(true);
          const allChecked =
            submitLinkList?.length > 0 &&
            submitLinkList.every((link) => link.is_submitted);
          setSubmittedLink(submitLinkList);
          if (allChecked) {
            setHasSubmitByPatient(true);
          } else {
            setHasSubmitByPatient(false);
          }
        } else {
          setIsAddedAssessment(false);
          setHasSubmitByDoctor(false);
        }
      } else {
        setIsAddedAssessment(false);
        console.log("13777");
      }
      if(message!='') {
        showToast("success", message);
      }
      // setIsLoading(false);
    } catch (error) {}
  };

  const handleInputChange = (index, value) => {
    const newLinks = [...links];
    newLinks[index] = value;
    setLinks(newLinks);
  };

  const handleBlur = () => {
    const trimmedLinks = links.map((link) => link.trim()); // Trim spaces for proper comparison
    const linkCounts = trimmedLinks.reduce((acc, link) => {
      acc[link] = (acc[link] || 0) + 1;
      return acc;
    }, {});

    const duplicates = Object.keys(linkCounts).filter(
      (link) => linkCounts[link] > 1
    );

    if (duplicates.length > 0) {
      showToast("error", "Duplicate links are not allowed.");
      console.log("Duplicate links found:", duplicates);
    }
  };

  // const isValidUrl = (url) => {
  //   const pattern = /^(https?:\/\/)?([\w\d-]+\.)+[\w\d-]+(\/[\w\d-._~:/?#[\]@!$&'()*+,;=]*)?$/;
  //   return pattern.test(url);
  // };
  const isValidUrl = (url) => {
    const pattern =
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]+(\/[\w\d-._~:/?#[\]@!$&'()*+,;=]*)*(#[\w\d-]*)?$/;
    return pattern.test(url);
  };

  const handleAddMore = () => {
    if (links.length >= 10) {
      showToast("error", "You can add up to 10 links only.");

      return;
    } else if (links.some((link) => !isValidUrl(link))) {
      // setUrlError("Please provide valid URLs.");
      showToast("error", "Please provide valid URLs.");
      return;
    } else if (links.length < 10) {
      setLinks([...links, ""]);
    } else {
      // setError("You can add a maximum of 10 links.");
    }

    setLinks([...links, ""]); // Add new empty input box
    setError("");
  };

  const handleRemove = (index) => {
    const newLinks = links.filter((_, i) => i !== index);
    setLinks(newLinks);
  };
  
  const checkUrlExistence = async (url) => {    
    const config = {
      method: 'get',
      url: VALIDATE_URL,
      params: {
        url: url
      },
      headers: {
        'accept': '*/*'
      }
    };
  
    try {
      const response = await axios(config);
      if (response.data?.data?.isValid) {
        return true;
      } else {
        return false;
      }
  
    } catch (error) {
      return false;
    }
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const linkCounts = links.reduce((acc, link) => {
      acc[link] = (acc[link] || 0) + 1;
      return acc;
    }, {});

    const duplicates = Object.keys(linkCounts).filter(
      (link) => linkCounts[link] > 1
    );

    if (duplicates.length > 0) {
      showToast("error", "Duplicate links are not allowed.");
      console.log("Duplicate links found:", duplicates);
      return;
    }

    const invalidLinks = links.filter((link) => !isValidUrl(link));

    if (invalidLinks.length > 0) {
      showToast("error", "Please provide valid URLs");
      return;
    }

    setisAddeAssesment(true);

    let invalidLinksCount = 0;
    let _invalidLinks = [];
    for (let link of links) {
      const urlStatus = await checkUrlExistence(link);
      if (!urlStatus) {
        invalidLinksCount++;
        _invalidLinks.push(link);
      }
    }

    if (invalidLinksCount > 0) {
      showToast("error", "Following URL(s) are invalid: " + _invalidLinks.join(', '));
      setisAddeAssesment(false);
      return;
    }

    const response = await CallWithAuth(
      "POST",
      `${SEND_PATIENT_ASSESMENT}${id}`,
      {
        links: links,
      }
    );
    // console.log(response);
    let message = errorMessageCreate(response?.res?.data?.message);

    // // Check the response status and show a toast message accordingly
    if (response?.res?.data?.statusCode === 201) {
      // showToast("success", message);
      // setTimeout(() => {
      //   navigate("/patient-information");
      // }, 1500);
      getAssesmentFromSubmitDetail(message);
    } else {
      showToast("error", message);
    }
    setisAddeAssesment(false);
    // Proceed with the submission if all links are valid
    // console.log("links==>", id, links);
  };
  const handleCheckboxChange = (id) => {
    setSubmittedLink((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isChecked: !item.isChecked } : item
      )
    );
  };

  const handleMailSend = async () => {
    // console.log("submittedLink==>", submittedLink);
    try {
      // let url = `${PATIENT_ASSESSMWNT_SUBMIT}${link.id}`;
      // console.log("url===>", url);
      const hasChecked =
        submittedLink.length > 0 &&
        submittedLink.some((link) => link.isChecked);
      if (hasChecked) {
        let assesmentIds = [];
        submittedLink?.map((linkObj, index) => {
          if (linkObj.isChecked) {
            assesmentIds.push(linkObj.id);
          }
        });
        setSubmitAssesmentLoading(true);
        let response = await CallWithAuth(
          "PATCH",
          `${PATIENT_ASSESSMWNT_SUBMIT}${id}`,
          {
            assessmentIds: assesmentIds,
          }
        );
        let message = errorMessageCreate(response?.res?.data?.message);

        if (response?.res?.data?.statusCode === 200) {
          showToast("success", message);
        } else {
          showToast("error", message);
        }
      } else {
        showToast("error", "Please select all links to submit.");
      }
    } catch (error) {}
    setSubmitAssesmentLoading(false);
  };
  const handleClickBack = async () => {
    navigate("/patient-information");
  };
  const handleGetRecommendation = async () => {

    try {
      const findPropmts = promptResult.find((item) => item.apiEndpointName === 'recommendation');
      // console.log("findPropmts==>", findPropmts);
      if (findPropmts === undefined) {
        showToast("error", "No endpoint found for the selected prompt.");
        return;
      }      
      setIsGetRecommendation(true);
      let response = await CallWithAuth(
        "POST",
        `${PATIENT_ASSESSMWNT_RECOMMENDED}${id}`,
        {
          prompt_text: findPropmts.promtText
        }
      );
      let message = errorMessageCreate(response?.res?.data?.message);
      // console.log("response==>sdf", response?.res?.data);
      
      if (response?.res?.data?.data?.status === "success") {
        setCount((pre) => pre + 1);
        setModalShow(true);
        setRecommendationDeatil(response?.res?.data?.data?.recommendations);
        setPromptTextChange(promptResult.find((item) => item.apiEndpointName === 'recommendation')?.promtText);
        // console.log(promptResult.find((item) => item.apiEndpointName === 'recommendations')?.promtText);
        
        setUpdatedPrompt(false);
      } else {        
        showToast("error", message);
        setRecommendationDeatil('');
      }
      setIsGetRecommendation(false);
    } catch (error) {
      console.log(error);
      setIsGetRecommendation(false);
    }
  };
  const handleClose = () => {
    setModalShow(false);
  };

  const handleChangePrompt = async () => {
    setUpdatedPrompt(isUpadatedPrompt ? false : true);
  }
  // console.log("submittedLink==>", submittedLink);
  // console.log("isAddedAssessment==>", isAddedAssessment);
  const oneAssemestChecked =
    submittedLink.length > 0 && submittedLink.some((link) => link.isChecked);

  const handlePromptInputChange = (fieldName, value) => {    
    setPromptTextChange(value)
  }
  const handleTestPrompt = async (reportData,field) => {
    // setPromptTextChange(reportData)
    // console.log("reportData==>", reportData);
    
    setRecommendationDeatil(reportData);

  }

  const handleUpdatePrompt = async (reportData,field,promptValue) => {
    setRecommendationDeatil(reportData);
     try {
       const response = await CallWithAuth(
         "GET",
         `${GET_PROMPTS}`
       );
       if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
         setPromptResult(response.res.data.data);
       }
       setIsLoading(false);
     } catch (error) {
      
     }
  }

  const handleReset = async (fieldName, value) => {
    setPromptTextChange(value?.promtText);
    // console.log("fieldName==>", fieldName);
    // console.log("value==>", value);
    // return;
    
    try {
       const response = await CallWithAuth(
         "GET",
         `${GET_PROMPTS}`
       );
       if (response.res.data && response.res.data.statusCode === 200) {
        //  setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
        setUpdatedPrompt(false);

       }
       setIsLoading(false);
     } catch (error) {
      
     }
  }
  return (
    <>
      {/* Modal Component */}
      <Modal show={modalShow} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Recommendation Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              fontSize: "20px",
              padding: "15px",
           background: "#F9FAFC",
              borderRadius: "10px",
              width: "100%",
            }}
            className="form-group report-container-new"
            dangerouslySetInnerHTML={{
              // __html: marked(reportgenerateData.collateral??""),
              __html: safeMarkedWrapper(marked(recommendationDeatil) ?? ""),
            }}
          />

            {isUpadatedPrompt ? (
              <PromptEditor
                field="recommendation"
                promptValue={promptTextChange|| ""}
                onChange={handlePromptInputChange}
                onTest={handleTestPrompt}
                onUpdate={handleUpdatePrompt}
                onCancel={handleChangePrompt}
                onReset={handleReset}
                cancelValue={promptTextChange}
                promptResult={promptResult}
              />):(
                
                 <button
            className="btn btn-primary"
              onClick={(e) =>
                handleChangePrompt(                               
                )
              }
              // disabled={isUpadatedPrompt}
            >
              Edit Prompts
            </button>)
            }
           
        </Modal.Body>
        <Modal.Footer>
        
          
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
           {/* <PromptEditor
                                    field="background_info"
                                    promptValue={promptData?.background_info || ""}
                                    onChange={handlePromptInputChange}
                                    onTest={handleTestPrompt}
                                    onUpdate={handleUpdatePrompt}
                                    onCancel={handleChangePrompt}
                                    onReset={handleReset}
                                    cancelValue={reportgenerateData.background_info_update_prompt}
                                    promptResult={promptResult}
                                  /> */}

        </Modal.Footer>
      </Modal>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Add Patient's Assesment</h1>
                  <p>E-Mail Send to Patient's</p>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  <img src={patient} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="site_container relative_table_new">
          <div className="row w-100 mx-auto mt-5">
            {/* {JSON.stringify(getRelativesDataDeatil)} */}
          </div>
          <div className="col-lg-10 offset-2">
            <div className="row customalign">
              <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 mt-4-sm-12 sm-12 mt-4">
                <strong>Patient Email:</strong>{" "}
                {textRetriever(getRelativesDataDeatil?.email)}
              </div>
              <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 mt-4-sm-12 sm-12 mt-4">
                <strong>Patient Name:</strong>{" "}
                {textRetriever(getRelativesDataDeatil?.full_name)}
              </div>

              <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 mt-4-sm-12 sm-12 mt-4">
                <strong>Patient submission:</strong>{" "}
                {/* {hasSubmitByPatient
                  ? "The patient has submitted the assessment"
                  : "The patient has not submitted it yet"} */}
                {!hasSubmitByDoctor && !hasSubmitByPatient
                  ? "Currently, doctor has not submitted the assessment & Patient has not received any links"
                  : hasSubmitByPatient
                  ? "The patient has submitted the assessment"
                  : "The patient has not submitted it yet"}
              </div>
              <div style={{ clear: "both" }}></div>
              {!isAddedAssessment && (
                <>
                  <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 mt-4-sm-12 sm-12 mt-4">
                    <h4>Manage Links (Max 10)</h4>
                  </div>
                  <div style={{ clear: "both" }}></div>
                  {links.map((link, index) => (
                    <div key={index} className="d-flex gap-2 mb-4 w-50">
                      <input
                        type="text"
                        value={link}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        placeholder={`Enter URL ${index + 1}...`}
                        className="form-control link-input"
                        onBlur={handleBlur} // Validate only when input loses focus
                      />
                      {index > 0 && (
                        <button
                          onClick={() => handleRemove(index)}
                          className="btn btn-danger"
                          disabled={links.length === 1}
                        >
                          <span>X</span>
                        </button>
                      )}
                    </div>
                  ))}
                  <div className="d-flex justify-content-center">
                    {links.length < 10 && (
                      <button
                        onClick={handleAddMore}
                        className="btn btn-primary mt-3"
                      >
                        Add More
                      </button>
                    )}
                    <button
                      onClick={handleSubmit}
                      className="btn btn-primary mt-3 ml-4"
                      style={{ marginLeft: "10px" }}
                      type="button"
                      disabled={isGetRecommendation}
                    >
                      {/* Submit */}
                      {assesment_loading ? (
                        <>
                          Create Assessment{" "}
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      ) : (
                        "Create Assessment"
                      )}
                    </button>

                    

                    {/* <button
                      className="btn btn-primary mt-3 ml-4"
                      onClick={handleGetRecommendation}
                      style={{ marginLeft: "10px" }}
                      disabled={isGetRecommendation}
                    >
                      Recommendation{" "}
                      {isGetRecommendation && (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      )}
                    </button> */}
                    <button
                      className="btn btn-primary mt-3 ml-4"
                      onClick={handleClickBack}
                      style={{ marginLeft: "10px" }}
                    >
                      Back
                    </button>
                  </div>
                </>
              )}
              <div style={{ clear: "both" }}></div>
              {submittedLink?.length > 0 && (
                <>
                  {submittedLink?.map((linkObj) => (
                    <div className="col-xl-6 col-lg-8 col-md-12 col-sm-12 mt-4-sm-12 sm-12 mt-4">
                      <div
                        key={linkObj.id}
                        className="d-flex justify-content-between align-items-center gap-2 customdesign"
                        // Optional width adjustment
                      >
                        {/* Checkbox */}
                        <input
                          type="checkbox"
                          className="form-check-input"
                          // checked={linkObj.isChecked || linkObj.is_submitted}
                          checked={linkObj.isChecked}
                          // disabled={linkObj.is_submitted}
                          onChange={() => handleCheckboxChange(linkObj.id)}
                        />

                        {/* Clickable Link */}
                        <a
                          href={linkObj.assessment_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary flex-grow-1"
                          style={{ wordBreak: "break-word" }}
                        >
                          {linkObj.assessment_link}
                        </a>
                      </div>
                    </div>
                  ))}
                  <div style={{ clear: "both" }}></div>
                  <div className="mx-auto d-flex justify-content-center">
                    <div className="col-lg-3">
                      <button
                        // disabled={!linkObj.isChecked || linkObj.is_submitted}
                        onClick={() => handleMailSend()}
                        className="btn btn-primary mt-5 px-3 py-2.5 w-100"
                        disabled={
                          !oneAssemestChecked || isSubmitAssesmentLoading 
                        }
                      >
                        {isSubmitAssesmentLoading ? (
                          <>
                            Resend Assessment
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        ) : (
                          "Resend Assessment"
                        )}
                      </button>
                    </div>
                   

                    <div className="col-lg-3">
                      <button
                        className="btn btn-primary mt-5 px-3 py-2.5 w-100"
                        onClick={handleClickBack}
                        style={{ marginLeft: "10px" }}
                        disabled={isGetRecommendation}
                      >
                        Back
                      </button>
                    </div>
                    <div className="col-lg-5">
                      {/* <button
                        className="btn btn-primary mt-5 px-3 py-2.5 w-50"
                        onClick={handleGetRecommendation} // Replace with the desired function
                        style={{ marginLeft: "21px" }}
                        disabled={isGetRecommendation}
                      >
                        Recommendation {" "}
                        {isGetRecommendation && (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        )}
                      </button> */}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="d-flex justify-content-center mt-4"></div>
          </div>
          <div className="d-flex justify-content-center mt-4"></div>
        </section>
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};
export default PatientAssesmentPage;
